import React from 'react'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Flex, DatePicker, List, WingBlank, WhiteSpace, InputItem, Tag } from 'antd-mobile'
import { Button, Modal } from 'components'
import _ from 'lodash'
import moment from 'moment'
import { handleAmount, intl } from 'utils'

const date = moment()
const minDate = new Date(2019, 9, 1, 0, 0, 0)
const maxDate = new Date(moment().endOf('month'))

export default class TansactionFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showFilter: false,
    }
  }

  handleSpecialProductCodes = () => {
    const { specialProductCodes } = this.props.initialValue
    if (specialProductCodes) {
      return _.isArray(specialProductCodes) ? specialProductCodes : [specialProductCodes]
    } else {
      return undefined
    }
  }

  formatDate = (date) => {
    return (
      <React.Fragment>
        <span>{moment(date).format('MM-YYYY')}</span>{' '}
        <span className='iconfont iconarrow-right-small font-md' />
      </React.Fragment>
    )
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      showFilter: !prevState.showFilter,
    }))
  }

  changeTransactionType = type => {
    this.props.form.setFieldsValue({
      tradeType: type
    })
  }

  changePaymentMethod = paymentMethod => {
    this.props.form.setFieldsValue({
      paymentMethods: [paymentMethod]
    })
  }

  handleReset = () => {
    // 重置条件不包含时间
    this.props.form.resetFields([
      'totalPage',
      'pageSize',
      'pageNum',
      'paymentMethods',
      'tradeType',
      'minAmount',
      'maxAmount',
    ])
    this.handleSubmit()
  }

  handleSubmit = () => {
    this.props.form.setFieldsValue({
      pageNum: 1,
    })
    this.props.query()
    this.setState({
      showFilter: false
    })
  }

  render() {
    const {
      form,
      initialValue = {},
      transactionType,
      paymentMethods,
      stats,
      totalPage = 0,
      pageSize = 20,
      pageNum = 1,
    } = this.props
    const aedAmount = _.find(stats, { currency : 'AED' })
    // const gpAmount = _.find(stats, { currency : 'GP' })
    var initialPaymentMethods = []
    if (initialValue.paymentMethods) {
      if (_.isArray(initialValue.paymentMethods)) {
        initialPaymentMethods = initialPaymentMethods.concat(
          initialValue.paymentMethods
        )
      } else {
        initialPaymentMethods.push(initialValue.paymentMethods)
      }
    } else {
      initialPaymentMethods.push('ALL')
    }
    return (
      <Flex className={classes.componentsTansactionFilter}>
        {form.getFieldDecorator('totalPage', {
          initialValue: totalPage,
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('pageSize', {
          initialValue: pageSize,
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('pageNum', {
          initialValue: pageNum,
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('cardId', {
          initialValue: initialValue.cardId,
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('specialProductCodes', {
          initialValue: this.handleSpecialProductCodes(),
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('combinePayShowCurrency', {
          initialValue: initialValue.combinePayShowCurrency,
        })(<InputItem className='dn' />)}
        <Flex.Item>
          <div className='text-left'>
            {form.getFieldDecorator('month', {
              initialValue: new Date(date),
            })(
              <DatePicker
                minDate={minDate}
                maxDate={maxDate}
                format={this.formatDate}
                mode='month'
                onOk={this.handleSubmit}
              >
                <List.Item arrow='down' />
              </DatePicker>
            )}
          </div>
          <p className='font-xs'>
            <b>
              <FormattedMessage {...messages.in} />{' '}
              {aedAmount &&
                handleAmount(
                  Object.assign(aedAmount, {
                    amount: aedAmount.incomeAmount,
                  })
                )}
              {/* {aedAmount && gpAmount && <span className={classes.gap}>&</span>}
              {gpAmount &&
                handleAmount(
                  Object.assign(gpAmount, {
                    amount: gpAmount.incomeAmount,
                  })
                )} */}
            </b>
          </p>
          <p className='font-xs'>
            <b>
              <FormattedMessage {...messages.out} />{' '}
              {aedAmount &&
                handleAmount(
                  Object.assign(aedAmount, {
                    amount: aedAmount.expenseAmount,
                  })
                )}
              {/* {aedAmount && gpAmount && <span className={classes.gap}>&</span>}
              {gpAmount &&
                handleAmount(
                  Object.assign(gpAmount, {
                    amount: gpAmount.expenseAmount,
                  })
                )} */}
            </b>
          </p>
        </Flex.Item>
        {/* 单独的tradeType和GP都隐藏筛选 */}
        {!initialValue.tradeType && initialPaymentMethods.indexOf('GP') < 0 && (
          <div className={`text-right ${classes.filterBtn}`} onClick={this.toggleFilter}>
            <span className='iconfont iconfilter font-mdplus' />
          </div>
        )}
        <Modal
          popup
          closable
          title='&nbsp;'
          animationType='slide-up'
          className={classes.filterModal}
          visible={this.state.showFilter}
          onClose={this.toggleFilter}
        >
          <WingBlank>
            <div className='font-xs'>
              <WhiteSpace size='lg' />
              <b>
                <FormattedMessage {...messages.transactionTypes} />
              </b>
              <WhiteSpace />
            </div>
            <div>
              <Flex wrap='wrap' align='center'>
                {form.getFieldDecorator('tradeType', {
                  initialValue: initialValue.tradeType || 'ALL',
                })(<InputItem className='dn' />)}
                {_.map(transactionType, (item) => {
                  return (
                    <Tag
                      key={item.name}
                      selected={form.getFieldValue('tradeType') === item.name}
                      onChange={() => this.changeTransactionType(item.name)}
                    >
                      {item.value}
                    </Tag>
                  )
                })}
                {_.times(transactionType % 3, String).map((index) => (
                  <Tag key={index} className='invisibal' />
                ))}
              </Flex>
            </div>
            <div className='font-xs'>
              <WhiteSpace size='lg' />
              <b>
                <FormattedMessage {...messages.payMethod} />
              </b>
              <WhiteSpace />
            </div>
            <div>
              <Flex wrap='wrap' align='center'>
                {form.getFieldDecorator('paymentMethods', {
                  initialValue: initialPaymentMethods,
                })(<InputItem className='dn' />)}
                {_.map(paymentMethods, (item) => {
                  return (
                    <Tag
                      key={item.name}
                      selected={
                        form.getFieldValue('paymentMethods')[0] === item.name
                      }
                      onChange={() => this.changePaymentMethod(item.name)}
                    >
                      {item.value}
                    </Tag>
                  )
                })}
                {_.times(paymentMethods % 3, String).map((index) => (
                  <Tag key={index} className='invisibal' />
                ))}
              </Flex>
            </div>
            <div className='font-xs'>
              <WhiteSpace size='xl' />
              <b>
                <FormattedMessage {...messages.setAmountRange} />
              </b>
              <WhiteSpace />
            </div>
            <List className='am-list-small no-border'>
              <Flex className={classes.setAmountRange}>
                {form.getFieldDecorator('minAmount', {
                  initialValue: '',
                  normalize: (value, prev) => {
                    if (!/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                      return prev
                    }
                    return value
                  },
                })(
                  <InputItem
                    type='text'
                    placeholder={intl.formatMessage(messages.min)}
                    moneyKeyboardAlign='left'
                  >
                    <b>
                      <FormattedMessage {...messages.aed} />
                    </b>
                  </InputItem>
                )}
                <Flex.Item className='text-center' style={{ marginLeft: 0 }}>
                  <span>-</span>
                </Flex.Item>
                {form.getFieldDecorator('maxAmount', {
                  initialValue: '',
                  normalize: (value, prev) => {
                    if (!/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                      return prev
                    }
                    return value
                  },
                })(
                  <InputItem
                    type='text'
                    placeholder={intl.formatMessage(messages.max)}
                    moneyKeyboardAlign='left'
                  >
                    <b>
                      <FormattedMessage {...messages.aed} />
                    </b>
                  </InputItem>
                )}
              </Flex>
            </List>
            <WhiteSpace size='xl' />
            <WhiteSpace />
            <Flex>
              <Flex.Item>
                <Button type='light' name='reset' onClick={this.handleReset} />
              </Flex.Item>
              <Flex.Item>
                <Button type='primary' name='ok' onClick={this.handleSubmit} />
              </Flex.Item>
            </Flex>
            <WhiteSpace size='xl' />
            <WhiteSpace size='xl' />
            <WhiteSpace size='xl' />
            <WhiteSpace size='xl' />
          </WingBlank>
        </Modal>
      </Flex>
    )
  }
}
